function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgIconMyheart = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 32 32"
}, props), /*#__PURE__*/React.createElement("path", {
  d: "M9.773 2.085a5.435 5.435 0 0 0-7.687 7.687l.571.571 7.687 7.687 7.687-7.687.571-.571a5.435 5.435 0 0 0-7.687-7.687l-.571.571z",
  "data-name": "Path 409",
  style: {
    fill: "none",
    stroke: "#000",
    strokeMiterlimit: 10,
    strokeWidth: "1.3px"
  },
  transform: "translate(5.7 6.5)"
}));
export default SvgIconMyheart;